module.exports = __webpack_public_path__ + "img/growing-plant.be4df7dc.svg";